
// Dataset names for API reference data
export const DATASET = {
  COUNTRIES: 'Countries'
}

// Global format for all dates
export const DATE_FORMAT = 'YYYY-MM-DD'
export const DATE_DISPLAY_FORMAT = 'DD MMM YYYY'

// Application statuses
export const STATUS = {
  RECEIVED: 'Received',
  IN_PROGRESS: 'In Progress',
  APPROVED: 'Approved',
  WITHDRAWN: 'Withdrawn'
}

export const EA_CHANGE_TYPES = {
  STATUS: 'STATUS',
  APP_DATA: 'APP_DATA'
}

export const EA_CATEGORY = {
  NEW: 'New',
  ASSIGNED: 'Assigned',
  COMPLETED: 'Completed'
}

export const EA_STATUS = {
  NEW: 'New',
  ASSIGNED: 'Assigned',
  INFO_REQ: 'Information Requested',
  PROCESSING_APP: 'Processing',
  APPROVAL_REQ: 'Approval Requested',
  APPROVAL_REQ_DENIED: 'Request Denied',
  APPROVAL_REQ_APPROVED: 'Request Approved',
  DISMISSED: 'Dismissed',
  DENIED: 'Denied',
  UNQUALIFIED: 'Unqualified',
  COMPLETED: 'Completed'
}

export const EA_ASSIGNED_CO_STATUS = {
  INFO_REQ: 'Information Requested',
  PROCESSING_APP: 'Processing',
  APPROVAL_REQ_APPROVED: 'Approval Requested',
  DISMISSED: 'Dismissed',
  DENIED: 'Denied',
  UNQUALIFIED: 'Unqualified',
}

export const EA_APPROVER_STATUS = {
  REQ_APPROVED: 'Request Approved',
  APPROVAL_REQ_DENIED: 'Request Denied',
}

export const EA_COMPLETED_STATUS = {
  DISMISSED: 'Dismissed',
  DENIED: 'Denied',
  UNQUALIFIED: 'Unqualified',
  COMPLETED: 'Completed'
}

// used to shrink analytics data to keep it under 150 bytes
export const EA_STATUS_ABBREV = {
  [EA_STATUS.NEW]: 'N',
  [EA_STATUS.ASSIGNED]: 'AS',
  [EA_STATUS.INFO_REQ]: 'IREQ',
  [EA_STATUS.PROCESSING_APP]: 'P',
  [EA_STATUS.APPROVAL_REQ]: 'AREQ',
  [EA_STATUS.REQ_APPROVED]: 'REQA',
  [EA_STATUS.APPROVAL_REQ_DENIED]: 'REQD',
  [EA_STATUS.APPROVAL_REQ_APPROVED]: 'AP',
  [EA_STATUS.DISMISSED]: 'DIS',
  [EA_STATUS.DENIED]: 'DIN',
  [EA_STATUS.UNQUALIFIED]: 'UQ'
}

export const EA_EDITABLE_STATUSES = [
  EA_STATUS.NEW,
  EA_STATUS.ASSIGNED,
  EA_STATUS.INFO_REQ,
  EA_STATUS.APPROVAL_REQ_DENIED,
  EA_STATUS.PROCESSING_APP
]

// Creating separate statuses to allow edit application
// as they are required to save the 'sendPCEmail' field
export const EA_STATUSES_FOR_OPT_OUT_EMAIL = [
  EA_STATUS.NEW,
  EA_STATUS.ASSIGNED,
  EA_STATUS.INFO_REQ,
  EA_STATUS.APPROVAL_REQ_DENIED,
  EA_STATUS.PROCESSING_APP
]

// icons to display in snackbar on update
export const EA_STATUS_CHANGED_ICONS = {
  [EA_STATUS.PROCESSING_APP]: 'mdi-checkbox-marked-circle',
  [EA_STATUS.DENIED]: 'mdi-close-circle-outline',
  [EA_STATUS.DISMISSED]: 'mdi-delete-outline',
  [EA_STATUS.APPROVAL_REQ_APPROVED]: 'mdi-checkbox-marked-circle',
  [EA_STATUS.APPROVAL_REQ_DENIED]: 'mdi-close-circle-outline',
  [EA_STATUS.REQ_APPROVED]: 'mdi-close-circle-outline',
  [EA_STATUS.UNQUALIFIED]: 'mdi-close-circle-outline',
  [EA_STATUS.APPROVAL_REQ]: 'mdi-checkbox-marked-circle',
  [EA_STATUS.NEW]: 'mdi-checkbox-marked-circle',
  [EA_STATUS.ASSIGNED]: 'mdi-checkbox-marked-circle'
}

const EA_OFFERED_STATUS_CHIP = {
  color: 'primary lighten-1',
  text: EA_STATUS.NEW.toUpperCase(),
  textColor: '#FFFFFF'
}

// props to pass into ADS Chip component
export const EA_STATUS_CHIPS = {
  [EA_STATUS.NEW]: {
    color: '#401250;',
    text: EA_STATUS.NEW.toUpperCase(),
    outlined: true
  },
  [EA_STATUS.ASSIGNED]: {
    color: '#C8DCF0',
    text: EA_STATUS.ASSIGNED.toUpperCase(),
    textColor: '#401250;'
  },
  [EA_STATUS.PROCESSING_APP]: {
    color: '#C8DCF0',
    text: EA_STATUS.PROCESSING_APP.toUpperCase(),
    textColor: '#401250;'
  },
  [EA_STATUS.APPROVAL_REQ_APPROVED]: {
    color: '#C8DCF0',
    text: EA_STATUS.APPROVAL_REQ_APPROVED.toUpperCase(),
    textColor: '#401250;'
  },
  [EA_STATUS.APPROVAL_REQ_DENIED]: {
    color: '#C8DCF0',
    text: EA_STATUS.APPROVAL_REQ_DENIED.toUpperCase(),
    textColor: '#401250;'
  },
  [EA_STATUS.DISMISSED]: {
    color: 'red base',
    text: EA_STATUS.DISMISSED.toUpperCase(),
    textColor: '#FFFFFF'
  },
  [EA_STATUS.DENIED]: {
    color: 'red base',
    text: EA_STATUS.DENIED.toUpperCase(),
    textColor: '#FFFFFF'
  },
  [EA_STATUS.UNQUALIFIED]: {
    color: 'red base',
    text: EA_STATUS.UNQUALIFIED.toUpperCase(),
    textColor: '#FFFFFF'
  },
  default: {
    color: '#401250;',
    outlined: true
  }
}

// props to pass into ADS Chip component
export const EA_STATUS_CHIPS_DARK_BACKGROUND = {
  [EA_STATUS.NEW]: {
    color: '#401250;',
    text: EA_STATUS.NEW.toUpperCase(),
    outlined: true
  },
  [EA_STATUS.ASSIGNED]: {
    color: '#C8DCF0',
    text: EA_STATUS.ASSIGNED.toUpperCase(),
    textColor: '#401250;'
  },
  [EA_STATUS.PROCESSING_APP]: {
    color: '#C8DCF0',
    text: EA_STATUS.PROCESSING_APP.toUpperCase(),
    textColor: '#401250;'
  },
  [EA_STATUS.APPROVAL_REQ_APPROVED]: {
    color: '#C8DCF0',
    text: EA_STATUS.APPROVAL_REQ_APPROVED.toUpperCase(),
    textColor: '#401250;'
  },
  [EA_STATUS.APPROVAL_REQ_DENIED]: {
    color: '#C8DCF0',
    text: EA_STATUS.APPROVAL_REQ_DENIED.toUpperCase(),
    textColor: '#401250;'
  },
  [EA_STATUS.DISMISSED]: {
    color: 'red base',
    text: EA_STATUS.DISMISSED.toUpperCase(),
    textColor: '#FFFFFF'
  },
  [EA_STATUS.DENIED]: {
    color: 'red base',
    text: EA_STATUS.DENIED.toUpperCase(),
    textColor: '#FFFFFF'
  },
  [EA_STATUS.UNQUALIFIED]: {
    color: 'red base',
    text: EA_STATUS.UNQUALIFIED.toUpperCase(),
    textColor: '#FFFFFF'
  },
  default: {
    color: '#401250;',
    outlined: true
  }
}
// Application field types (see README.md)
export const FIELD_TYPE = {
  HEADING: 'HEADING',
  LINEBREAK: 'LINEBREAK',
  COLLECTION: 'COLLECTION',
  GROUP: 'GROUP',
  TEXTAREA: 'TEXTAREA',
  DROPLIST: 'DROPLIST',
  DATE: 'DATE',
  MONTH_YEAR: 'MONTH_YEAR',
  MM_YYYY: 'MM_YYYY',
  RADIO: 'RADIO',
  POSTCODE: 'POSTCODE',
  PHONE: 'PHONE',
  EMAIL: 'EMAIL',
  NAME: 'NAME',
  ADDRESS: 'ADDRESS',
  CUSTOM: 'CUSTOM',
  RECORD: 'RECORD', // Special type set automatically for collection records,
  FILE_EDITOR: 'FILE_EDITOR',
  MESSAGE: 'MESSAGE',
  CURRENCY: 'CURRENCY',
}

// Categories of alert. Each category is shown in a separate section of the Actions list.
export const ALERT_TYPE = {
  MISSING: 'MISSING', // Required field is empty
  INVALID: 'INVALID', // Field failed validation (prevents user from saving)
  CONFLICT: 'CONFLICT', // Field conflicts with EA APPLICATION value
  ALERT: 'ALERT', // Custom alert criteria has returned a message to display (user can still save and also ignore alert)
  LINKING_FAIL: 'LINKING_FAIL' // A record could not be auto-linked, so should be linked manually. Only alerted if unlinked EA APPLICATION records are present.
}

// String matching modes
export const MATCH = {
  EXACT: 'EXACT', // Apply exact matching
  INSENSITIVE: 'INSENSITIVE', // Apply case insensitive matching
  FUZZY: 'FUZZY' // Apply fuzzy matching
}

// Values for address validationFlag
export const ADDRESS_VALIDATION = {
  VALIDATED: 'V',
  ACCEPTED: 'A',
  UNKNOWN: 'N'
}

// When resolving record linking, any record marked as 'new' by the user will be assigned this id as the linked value. It indicates that there is no linked EA APPLICATION record, and that this linking is now resolved.
export const NEW_RECORD = -1

// Values for address validationFlag
export const USER_GROUP = {
  CASE_OFFICER: 'caseofficer',
  ADMIN_OFFICER: 'AdminOfficer'
}


// Options for Yes/No radio buttons
export const YES_NO = [
  { text: 'Yes', value: true },
  { text: 'No', value: false }
]

// Values used to differentiate between different application streams
export const STREAM = {
  EA: 'EA'
}

export const NODE_ENVIRONMENTS = {
  LOCAL: 'LOCAL',
  DEV: 'DEV',
  TEST: 'TEST',
  PREPROD: 'PRE',
  PROD: 'PROD',
  TRAIN: 'TRAIN'
}

export const SUPPORTING_DOCS = [
  { category: 'studentIdentity', label: 'Proof of student’s identity' },
  {
    category: 'travel',
    label: "Student's passport, visa and travel documents"
  },
  { category: 'familyLaw', label: 'Family law or other relevant court orders' },
  {
    category: 'residentialAddress',
    label: 'Proof of student’s residential address'
  },
  {
    category: 'disability',
    label: 'Evidence of any disability or other support needs'
  },
  {
    category: 'immunisation',
    label: 'Student’s immunisation history statement'
  },
  {
    category: 'medical',
    label: "Student's medical/healthcare or emergency action plans"
  }
]

export const FILE_STATUSES = {
  SAFE: 'SAFE',
  INFECTED: 'INFECTED-REPLACED',
  TO_BE_SCANNED: 'UNSCANNED',
  MISSING: 'MISSING'
}

// address abbreviations
export const ADDRESS_MAPPINGS = [
  ['STREET', 'ST'],
  ['ROAD', 'RD'],
  ['CRESCENT', 'CR'],
  ['CLOSE', 'CL'],
  ['AVENUE', 'AV'],
  ['PLACE', 'PL'],
  ['DRIVE', 'DR'],
  ['GROVE', 'GR'],
  ['CIRCUIT', 'CCT'],
  ['HIGHWAY', 'HWY'],
  ['BOULEVARD', 'BVD'],
  ['PARADE', 'PDE'],
  ['COURT', 'CT'],
  ['GREEN', 'GRN'],
  ['PARKWAY', 'PWY'],
  ['ALLEY', 'ALLY'],
  ['APPROACH', 'APP'],
  ['ARCADE', 'ARC'],
  ['BOARDWALK', 'BWLK'],
  ['BREAK', 'BRK'],
  ['BYPASS', 'BYPA'],
  ['CHASE', 'CH'],
  ['CONCOURSE', 'CON'],
  ['CREST', 'CRST'],
  ['ENTRANCE', 'ENT'],
  ['ESPLANADE', 'ESP'],
  ['FREEWAY', 'FWY'],
  ['GLADE', 'GLDE'],
  ['GRANGE', 'GRA'],
  ['PASSAGE', 'PSGE'],
  ['PROMENADE', 'PROM'],
  ['QUAYS', 'QYS'],
  ['RETREAT', 'RTT'],
  ['RIDGE', 'RDGE'],
  ['SUBWAY', 'SBWY'],
  ['TERRACE', 'TCE'],
  ['TRACK', 'TRK'],
  ['TRAIL', 'TRL'],
  ['VISTA', 'VSTA'],
  ['WHARF', 'WHRF']
]


export const FILE_UPLOAD_ERROR_TYPES = {
  FILE_SIZE: 'EXCEED_MAX_FILE_SIZE',
  FILE_TYPE: 'INVALID_FILE_TYPE',
  FILE_NAME: 'INVALID_FILE_NAME',
  EXCEED_MAX_FILES: 'EXCEED_MAX_FILES'
}

export const GENDER_OPTIONS = [
  {
    label: 'Male',
    value: 'M'
  },
  {
    label: 'Female',
    value: 'F'
  }
]

export const YES_NO_OPTIONS = [
  {
    label: 'Yes',
    value: true
  },
  {
    label: 'No',
    value: false
  }
]

export const REFDATA_MAP = {
  RELATIONSHIP: 'Relationship',
  TITLE: 'Title',
  LANGUAGES: 'Languages',
  LANGUAGES_POPULAR: 'LanguagesPopular',
  CONTACT_TYPE: 'ContactType',
  STATES: 'States'
}